// src/pages/AdminOrgRootRedirect.tsx
import { Navigate, useParams } from 'react-router-dom';
import { adminOrgPath, type AdminSection } from '../utils/adminRoutes';

const AdminOrgRootRedirect: React.FC = () => {
  const { companyId: raw } = useParams<{ companyId: string }>();
  const companyId = raw ? decodeURIComponent(raw) : '';
  if (!companyId) {
    return <Navigate to="/admin" replace />;
  }
  return <Navigate to={adminOrgPath(companyId, 'dashboard' as AdminSection)} replace />;
};

export default AdminOrgRootRedirect;
